import Password from "./PasswordGenerator/Password";
function App() {
  return (
    <>
    <Password/>
    </>
  );
}

export default App;
